import { createSlice } from "@reduxjs/toolkit"
import api from "../../api/services"
import { Apply4Response } from "../../api/types/apply4"

type initialState = {
    response: Apply4Response | null
}

const apply4Slice = createSlice({
    name: "apply4",
    initialState: { response: null } as initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(
            api.endpoints.apply4.matchFulfilled,
            (state, action) => {
                state.response = action.payload
            }
        )
    }
})

export default apply4Slice.reducer




